import { Select, TextInput } from '@mantine/core'

import DNButton from 'src/components/Buttons/Button/DNButton'
import { DISQUALIFIED_REASON_OPTIONS } from 'src/lib/disqualifiedReason.utils'

import SettingsField from '../../../components/SettingsField'

const VARIABLE_TYPE_OPTIONS = [
  { value: 'STRING', label: 'Text' },
  { value: 'NUMBER', label: 'Number' },
  { value: 'BOOLEAN', label: 'Yes/No' },
]

const QuestionTemplate = ({
  questionTemplate,
  index,
  removeQuestionTemplate,
  disabled,
  updateQuestionTemplate,
  showTechnicalFields = true,
  canModifyQuestions = true,
}) => {
  return (
    <div
      key={index}
      className="flex flex-col gap-4 border-b border-doubleNickel-gray-200 pb-4"
    >
      <SettingsField
        className="grid grid-cols-2 items-start"
        title={
          questionTemplate.shortQuestionName?.trim() ||
          questionTemplate.variableName?.trim() ||
          `Question ${index + 1}`
        }
        description={
          questionTemplate.question?.trim() || 'Please fill out the question'
        }
      >
        <div className="grid w-full grid-cols-2 gap-4 ">
          <TextInput
            label="Question Text"
            placeholder="e.g., Do you have a class A CDL license?"
            value={questionTemplate.question}
            onChange={(e) => {
              const questionText = e.target.value
              updateQuestionTemplate(index, 'question', questionText)
            }}
            disabled={disabled}
            size="xs"
          />

          {showTechnicalFields && (
            <TextInput
              label="Variable Name"
              placeholder="e.g., hasClassACDLicense"
              value={questionTemplate.variableName}
              onChange={(e) =>
                updateQuestionTemplate(index, 'variableName', e.target.value)
              }
              disabled={disabled}
              size="xs"
            />
          )}

          <TextInput
            label="Short Name (Optional)"
            placeholder="e.g., CDL Class A"
            value={questionTemplate.shortQuestionName || ''}
            onChange={(e) =>
              updateQuestionTemplate(index, 'shortQuestionName', e.target.value)
            }
            disabled={disabled}
            size="xs"
          />

          {showTechnicalFields && (
            <Select
              label="Answer Type"
              data={VARIABLE_TYPE_OPTIONS}
              value={questionTemplate.variableType}
              onChange={(value) =>
                updateQuestionTemplate(index, 'variableType', value)
              }
              disabled={disabled}
              size="xs"
            />
          )}

          {showTechnicalFields && (
            <TextInput
              label="Condition (Optional)"
              placeholder="e.g., depends on previous answer"
              value={questionTemplate.condition || ''}
              onChange={(e) =>
                updateQuestionTemplate(index, 'condition', e.target.value)
              }
              disabled={disabled}
              size="xs"
            />
          )}

          <Select
            label="Disqualified Reason (Optional)"
            placeholder="Select disqualification reason"
            data={DISQUALIFIED_REASON_OPTIONS}
            value={questionTemplate.disqualifiedReason || ''}
            onChange={(value) =>
              updateQuestionTemplate(index, 'disqualifiedReason', value)
            }
            disabled={disabled}
            size="xs"
            clearable
          />
        </div>
      </SettingsField>
      {canModifyQuestions && (
        <DNButton
          variant="secondary"
          onClick={() => removeQuestionTemplate(index)}
          className="ml-auto"
          disabled={disabled}
        >
          Delete question
        </DNButton>
      )}
    </div>
  )
}

export default QuestionTemplate
